import { css } from "@emotion/react";
import FrjStacked from "../../../assets/frj-logo-new-dark.png";

export const FrjLogoWithTitle = ({
  featureImage,
  title,
}: {
  featureImage?: string;
  title?: string;
}) => {
  return (
    <div>
      <div
        css={css`
          display: flex;
          gap: 16px;
        `}
      >
        {featureImage && (
          <img
            css={css`
              width: 8px;
            `}
            src={featureImage}
            alt={title}
          />
        )}
        <div>
          <img src={FrjStacked} alt="Financial Remedies Journal" />
          <div
            css={css`
              color: rgba(0, 0, 0, 0.6);
              font-family: Spectral;
              font-size: 20px;
              font-weight: 700;
              margin-top: -6px;
            `}
          >
            {title?.replace("Financial Remedies Journal – ", "")}
          </div>
        </div>
      </div>
    </div>
  );
};
